import { render, staticRenderFns } from "./ProspectItem.vue?vue&type=template&id=796c6155&scoped=true&"
import script from "./ProspectItem.vue?vue&type=script&lang=js&"
export * from "./ProspectItem.vue?vue&type=script&lang=js&"
import style0 from "./ProspectItem.vue?vue&type=style&index=0&id=796c6155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c6155",
  null
  
)

export default component.exports